import type { Meta, StoryFn } from '@storybook/react';

import { CardContent, Flex, Fullscreen, ListToolbar, Text } from '@pega/cosmos-react-core';

import { StyledFullscreenCard } from './Fullscreen.styles';

export default {
  title: 'Core/Fullscreen',
  component: Fullscreen,
  parameters: {
    layout: 'centered'
  }
} as Meta;

export const FullscreenDemo: StoryFn = () => {
  return (
    <Fullscreen>
      <StyledFullscreenCard>
        <CardContent>
          <Flex container={{ direction: 'column' }}>
            <ListToolbar name='Fullscreen demo' />
            <Text as='p'>This card can be toggled in and out of fullscreen size.</Text>
          </Flex>
        </CardContent>
      </StyledFullscreenCard>
    </Fullscreen>
  );
};
